import ReactSlider from 'react-slider';
import styled, { css } from 'styled-components';

const Slider = styled(ReactSlider)`
  width: 100%;
  height: 10px;
`;

export default Slider;

export const WrapperSlider = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const WrapperTrack = styled.div`
  top: 0;
  bottom: 0;
  background-color: ${({ index }) => (index !== 1 ? '#FFC709' : '#DDD')};
  border-radius: 999px;

  ${({ isMultiple }) => isMultiple && css`
    background-color: ${({ index }) => (index === 1 ? '#FFC709' : '#DDD')};
  `};
`;

export const WrapperThumb = styled.div`
  cursor: grab;
  user-select: none;
  top: -6px;
  height: 25px;
  width: 25px;
  line-height: 25px;
  text-align: center;
  background-color: #FFC709;
  border-radius: 50%;

  ${({ isDisabled }) => isDisabled && css`
    cursor: not-allowed;
    background-color: #DDD;
  `};
`;

export const ThumbTitle = styled.span`
    bottom: 25px;
    position: relative;
    display: block;
    font-size: 0.9rem;
    font-weight: bold;
    color: #fff;
`;
